export default __webpack_public_path__ + "static/media/animation-1.19dd0d18.gif";